import styled from 'styled-components';

import colors from 'themes/Main';

const { gray03, white } = colors;

export const ProjectActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 64px 0 32px;

  > div {
    align-items: center;
    display: flex;

    > div:last-child {
      margin-left: 16px;
    }
  }
`;

export const FormGroup = styled.div``;

export const ProjectInfos = styled.div`
  margin: -32px 0 64px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

export const Projects = styled.div``;

export const Callback = styled.div`
  width: 100%;
  background-color: ${white};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 64px;
`;

export const CallbackText = styled.h2`
  width: 500px;
  margin-top: 32px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${gray03};
  text-align: center;

  p {
    display: block;
    margin-bottom: 8px;
  }
`;

export const Loader = styled.div`
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6);
`;
